import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

export type RequireAuthProps = {
    // The protected content to render once the user is confirmed to be logged in
    children: ReactElement;
}

// Redirects to the login page if the user has no active session, remembering where they came from
const RequireAuth = (props: RequireAuthProps) => {
    const location = useLocation();
    const token: string | undefined = Cookies.get('token');

    if(!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return props.children;
}

export default RequireAuth;
